import React from "react";
import { useLanguage } from "../../i18n/LanguageContext";
import { cn } from "../../lib/utils";

const MarkdownOutline = ({ sections, activeId, onSelect, variant = "sidebar" }) => {
  const { t } = useLanguage();

  if (!sections?.length) return null;

  const handleClick = (id) => {
    onSelect?.(id);
  };

  if (variant === "chips") {
    return (
      <div className="lg:hidden mb-3" data-testid="outline-chips">
        <p className="text-xs font-medium text-muted-foreground mb-2">
          {t("query.jumpToSection")}
        </p>
        <div className="flex gap-1.5 overflow-x-auto pb-1 -mx-1 px-1">
          {sections.map((section) => (
            <button
              key={section.id}
              type="button"
              onClick={() => handleClick(section.id)}
              aria-current={activeId === section.id ? "true" : undefined}
              className={cn(
                "flex-shrink-0 px-2.5 py-1 rounded-full border text-xs transition-colors",
                activeId === section.id
                  ? "bg-primary/10 text-primary border-primary/30"
                  : "border-border text-muted-foreground hover:text-foreground hover:border-primary/20"
              )}
              data-testid={`outline-chip-${section.id}`}
            >
              {section.label}
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <nav
      className="sticky top-28 max-h-[calc(100vh-12rem)] overflow-y-auto pr-2"
      aria-label={t("query.jumpToSection")}
      data-testid="outline-sidebar"
    >
      <p className="text-xs font-medium text-muted-foreground mb-2 uppercase tracking-wide">
        {t("query.jumpToSection")}
      </p>
      <ul className="space-y-0.5">
        {sections.map((section) => (
          <li key={section.id}>
            <button
              type="button"
              onClick={() => handleClick(section.id)}
              aria-current={activeId === section.id ? "true" : undefined}
              className={cn(
                "w-full text-left text-sm py-1.5 px-2 rounded-md transition-colors truncate",
                section.level === 3 && "pl-5 text-xs",
                section.level === 1 && "font-medium",
                activeId === section.id
                  ? "bg-primary/10 text-primary"
                  : "text-muted-foreground hover:text-foreground hover:bg-muted/50"
              )}
              data-testid={`outline-item-${section.id}`}
            >
              {section.label}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default MarkdownOutline;
